import React from 'react';
import { Modal, Form, Input } from 'antd';
  
  const PermissionDialogForm = Form.create({ name: 'form_in_modal' })(
    // eslint-disable-next-line
    class extends React.Component {
      render() {
        const { visible, onCancel, onCreate, form, data} = this.props;
        const { getFieldDecorator } = form;

        return (
          <Modal
            visible={visible}
            title="Add Permission"
            okText="Save"
            onCancel={onCancel}
            onOk={onCreate}>

            <Form layout="vertical">
              <Form.Item label="Permission Name">
                {getFieldDecorator('name', {
                 initialValue: data.name,
                  rules: [{ required: true, message: 'Please input the Permission Name!' }],
                })( <Input /> )}
              </Form.Item>
            </Form>

          </Modal>
        );
      }
    }
  );

  export default PermissionDialogForm;
